import { useCallback, useEffect, useState } from "react";

import { addNewOption, loadOptions } from "../../utils/loadOptions";

import Creatable from "react-select/creatable";
import { withAsyncPaginate } from "react-select-async-paginate";

const CreatableAsyncPaginate = withAsyncPaginate(Creatable);

const CreateAsyncPaginateDropdown = ({
  value,
  onChange,
  className,
  searchPayload,
  setSearchPayload,
}) => {
  const [cacheUniq, setCacheUniq] = useState(0);
  const [isAddingInProgress, setIsAddingInProgress] = useState(false);
  const wrappedLoadOptions = useCallback((...args) => {
    return loadOptions(...args);
  }, []);

  const onCreateOption = useCallback(async (inputValue) => {
    setIsAddingInProgress(true);

    const newOption = await addNewOption(inputValue);
    setIsAddingInProgress(false);
    setCacheUniq(increaseUniq);
    onChange(newOption);
  }, []);

  const increaseUniq = (uniq) => uniq + 1;

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#f0f0f0", // Change background color of the control
      borderColor: state.isFocused ? "transparent" : "transparent", // Change border color
      minHeight: "50px", // Change the height of the control
      boxShadow: "transparent",
      "&:hover": {
        boxShadow: "transparent",
        borderColor: "transparent", // Set border color to transparent on hover
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "gray" : "white", // Change background color of selected option
      color: state.isSelected ? "white" : "black", // Change text color of selected option
      padding: 20, // Change padding
    }),
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: "lightgray", // Change background color of the menu
      borderRadius: "5px", // Change border radius of the menu
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "gray", // Change color of the selected value
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#000",
    }),
  };

  console.log(value, "value");

  useEffect(() => {
    if (!!value) {
      setSearchPayload({ ...searchPayload, location: value?.value });
    }
  }, [value]);

  const formatCreateLabel = (inputValue) => `Search ${inputValue}`;

  return (
    <CreatableAsyncPaginate
      isDisabled={isAddingInProgress}
      styles={customStyles}
      className={[className, " custom-placeholder"]}
      debounceTimeout={300}
      onCreateOption={onCreateOption}
      placeholder="Enter Location or Description"
      value={value}
      loadOptions={wrappedLoadOptions}
      formatOptionLabel={({ label, type }) => (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <strong>{label}</strong>
          <small style={{ marginLeft: 'auto' }}>{type}</small>
        </div>
      )}
      onChange={onChange}
      cacheUniqs={[cacheUniq]}
      formatCreateLabel={formatCreateLabel}
    />
  );
};

export default CreateAsyncPaginateDropdown;
